import { getField, updateField } from 'vuex-map-fields';

const getters = {
    getField,
};

const state = {
    salesOrdersWithPageInfo: {},
    salesOrders: [],
    pagination: {
        page: 1,
        total: 0,
        rowsPerPage: 20
    },
    view: 'table-view',
};

const mutations = {
    updateField,
};

const actions = {

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};